import { render, staticRenderFns } from "./UserNoRoleOverlay.vue?vue&type=template&id=7532aa77&scoped=true"
import script from "./UserNoRoleOverlay.vue?vue&type=script&lang=js"
export * from "./UserNoRoleOverlay.vue?vue&type=script&lang=js"
import style0 from "./UserNoRoleOverlay.vue?vue&type=style&index=0&id=7532aa77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532aa77",
  null
  
)

export default component.exports